import { useMemo } from 'react';
import { ElementPopup, preloadElements, type ElementPopupToast } from '@flobi/asset-library/elements';
import '@flobi/asset-library/elements.css';
import { currentTokenGetter } from '../../services/apiClient';
import './elements.css';

/*
 * The element popup, in Artwork: the one every Flobi app opens (`@flobi/asset-library/elements`,
 * moved out of Flow — the same form, uploads, sheets, jobs and pricing everywhere), mounted here as
 * a component and drawn in Artwork's colours (the --el-* tokens in elements.css). Tarek, 14 Oct:
 * "just open it like a normal component inside artwork".
 */

const BASE_URL = (import.meta.env.VITE_BACKEND_URL as string | undefined) ?? '';
const FLOW_URL = (import.meta.env.VITE_FLOW_URL as string | undefined) || (import.meta.env.DEV ? 'http://localhost:3000' : 'https://flow.flobi.ai');
const getToken = async () => (await currentTokenGetter()?.().catch(() => null)) ?? null;

/** Loads the element catalog ahead of the first click, so the popup opens at once. */
export function preloadElementPopup() {
  if (currentTokenGetter()) void preloadElements({ getToken, baseUrl: BASE_URL }).catch(() => undefined);
}

export function ElementEditor({ element, projectId, brand, onChanged, onClose, onUse, onNotice }: {
  element?: { id: string; kind: string }; projectId?: string | null;
  /** The file's brand: a new element is that brand's too, and ⋯ offers Add to / Remove from it. */
  brand?: { id: string; name?: string } | null;
  onChanged(id: string): void; onClose(): void; onUse?(id: string): void; onNotice(message: string): void;
}) {
  const toast = useMemo<ElementPopupToast>(() => ({ error: onNotice, success: onNotice, warning: onNotice, message: onNotice }), [onNotice]);
  return <ElementPopup getToken={getToken} baseUrl={BASE_URL} flowUrl={FLOW_URL} element={element ?? null} driveProjectId={projectId ?? null} brand={brand ?? null}
    actionLabel={onUse ? 'Use in Generate' : undefined} onAction={onUse} toast={toast}
    onClose={onClose} onChanged={onChanged} onCreated={onChanged} onDeleted={onChanged} />;
}
